<template>
  <div style="margin: 0 48px 8px 24px;">
    <el-form ref="formRef" :model="configForm" label-width="auto" label-position="right">
      <el-form-item label="所属门店：">
          {{configForm.shopName}}
      </el-form-item>
      <el-form-item label="实付返医疗金比例（%）：">
        <el-input v-model="configForm.medicalBenefitPct" placeholder="请输入实付返医疗金比例" />
      </el-form-item>
      <el-form-item label="券后返医疗金金额（元）：">
        <el-input v-model="configForm.medicalBenefitMoney" placeholder="请输入券后返医疗金金额" />
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" :disabled="loading" v-loading="loading" >确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData, imgPostFormData } from "@/api/api"
import { updateShopConfig} from "@/api/url";
import { positiveIntReg } from "@/assets/shared/reg-constant";

export default {
  name: "BannerDialog",
  props: {
    value: Object
  },
  data() {
    return {
      configForm: this.value.configForm,
      idx: this.value.ids,
      loading: false
    }
  },
  methods: {

    disabledDate(time) {
      let today = new Date()

      return time.getTime() < (today.getTime() - 24*60*60*1000)
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!positiveIntReg.test(this.configForm.medicalBenefitPct) || this.configForm.medicalBenefitPct > 100) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入正确的实付返医疗金比例',
          type: 'warning'
        });
        return false
      }
      if(!positiveIntReg.test(this.configForm.medicalBenefitMoney)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入正确的券后返医疗金金额',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {};
      param['id'] = this.configForm.id;
      param['medicalBenefitPct'] = this.configForm.medicalBenefitPct;
      param['medicalBenefitMoney'] = this.configForm.medicalBenefitMoney;
      postFormData(updateShopConfig, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      })
    },


  },
  mounted() {

  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  margin: 0 auto
}
</style>
